<div class="d-flex flex-column flex-sm-row input-btn-group mb-2">
  <div class="mb-2 me-sm-2">
    <button class="btn btn-primary btn-lg w-100" (click)="openAddCompanyForm()">
      + Add Monitoring Company
    </button>
  </div>
  @if (mCompanyCountTotal > 5) {
    <div class="flex-sm-grow-1">
      <gtapp-auto-complete
        [data]="companyDropDownList"
        placeHolder="Search Monitoring Companies"
        searchKeyword="company_name"
        [itemTemplate]="mCTemplate"
        (inputChanged)="onCompanyLookup($event)"
        (selected)="openEditCompanyForm($event)"
        (submitted)="globalFilter = $event; fetchMonitoringCompanyList()"
      >
      </gtapp-auto-complete>
      <ng-template #mCTemplate let-item>
        <div>{{ item?.company_name }}</div>
      </ng-template>
    </div>
  }
</div>
@if (mCompanyCountTotal > 0) {
  <gtapp-card-list
    [mobileCardBackendData]="monitoringCompanyList"
    [mobileCardDetails]="cardDetails"
    [mobileActionIcons]="cardActionIcons"
    [otherParams]="otherParams"
    (actionClick)="deleteCompany($event?.event)"
    (rowClick)="openEditCompanyForm($event)"
    (paginationChange)="onChangePagination($event)"
  ></gtapp-card-list>
}
